"use strict";
import _ from "underscore";
import CarrierService from "../../services/carrier_service";
import TMSShipmentsStore from "../../stores/tms_shipments_store";
import TMSCustomerLoadsStore from "../../stores/tms_customer_loads_store";
import TMSStopsStore from "../../stores/tms_stops_store";
import TMSDeliveriesStore from "../../stores/tms_deliveries_store";
import FactoringCompaniesStore from "../../stores/factoring_companies_store";
import FactoringAssignmentsStore from "../../stores/factoring_assignments_store";
import FactoringCompanyOfficesStore from "../../stores/factoring_company_offices_store";
import NetworkBrokersStore from "../../stores/network_brokers_store";
import PaymentAddressesStore from "../../stores/payment_addresses_store";
import "../../stores/document_group_store";
import "../documents_service";
export default {
  carrier: function(load) {
    return CarrierService.getCarrierOrUnknown(
      load.invoice_carrier_id || load.carrier_id
    );
  },
  carrierPromise: function(load) {
    return CarrierService.carrierWithId(
      load.invoice_carrier_id || load.carrier_id
    );
  },
  carrierById: function(id) {
    return CarrierService.carrierWithId(id);
  },
  labels: function(item) {
    if (item.__type === "LoadState") {
      return this.labels(item.carrier_invoice);
    } else {
      if (!_.isEmpty(item.labels)) {
        return _.map(item.labels, function(label) {
          return label.name ? label.name : label;
        });
      }
    }
  },
  carriers: function(item) {
    return _.map(this.carrierIds(item), CarrierService.getCarrierOrUnknown);
  },
  carrierIds: function(object) {
    if (!object) {
      return [];
    }
    switch (object.__type) {
      case "ExceptionedItem":
        var item = object.loadState || object.document_batch || object.email_message || object.carrierInvoice || object.factorInvoice;
        return item ? this.carrierIds(item) : [];
      default:
        return object.carrier_ids || [object.carrier_id];
    }
  },
  factoringCompany: function(object) {
    return FactoringCompaniesStore.find(object.factoring_company_id);
  },
  factoringCompanyOffice: function(object) {
    if (object.__type === "Carrier") {
      var factoringAssignments = this.factoringAssignments(object);
      var factoringAssignment = _.findWhere(factoringAssignments, {
        terminated_at: null
      });
      return this.factoringCompanyOffice(factoringAssignment);
    } else {
      return FactoringCompanyOfficesStore.find(
        object.factoring_company_office_id
      );
    }
  },
  networkBroker: function(object) {
    return NetworkBrokersStore.find(object.network_broker_id);
  },
  factoringCompanyOffices: function(object) {
    return FactoringCompanyOfficesStore.findAll(
      object.factoring_company_office_ids
    );
  },
  factoringAssignments: function(object) {
    return _.where(FactoringAssignmentsStore.items, { carrier_id: object.id });
  },
  paymentAddress: function(object) {
    return PaymentAddressesStore.find(object.payment_address_id);
  },
  tmsShipment: function(object) {
    return TMSShipmentsStore.find(object.tms_shipment_id);
  },
  tmsShipments: function(object) {
    return TMSShipmentsStore.findAll(object.tms_shipment_ids);
  },
  tmsCustomerLoads: function(object) {
    return TMSCustomerLoadsStore.findAll(object.tms_customer_load_ids);
  },
  tmsStop: function(object) {
    return TMSStopsStore.find(object.tms_stop_id);
  },
  tmsStops: function(object) {
    return TMSStopsStore.findAll(object.tms_stop_ids);
  },
  tmsDrops: function(object) {
    return TMSStopsStore.findAll(object.tms_stop_ids).filter(
      (stop) => stop.type === "TMS::Drop"
    );
  },
  tmsDropDeliveries: function(object) {
    const dropIds = this.tmsDrops(object).map((d) => d.id);
    const shipmentIds = this.tmsShipments(object).map((s) => s.id);
    return TMSDeliveriesStore.findAll(object.tms_delivery_ids).filter((delivery) => dropIds.indexOf(delivery.tms_stop_id) !== -1).filter(
      (delivery) => shipmentIds.indexOf(delivery.tms_shipment_id) !== -1
    );
  },
  tmsDeliveries: function(object) {
    return TMSDeliveriesStore.findAll(object.tms_delivery_ids);
  }
};
